import { TIME_SERIES } from 'reporting-data/constants/configTypes';
import { getConfigType, getDataType, getDateRangeFilter, getDateRangeFilterProperty, getDimensions, getReportConfig } from 'reporting-data/report/configReportGetters';
import { getCustomWidgetType, isTableReport } from 'reporting-data/report/reportGetters';
import { CUSTOM_WIDGET_TYPES } from 'reporting-data/tsTypes/customWidgetTypes';
import { isConfigReport, isMultiConfigReport } from 'reporting-data/tsTypes/reportTypes';
const EXT_LINE_ITEMS_JOINED_DEALS = 'EXT_LINE_ITEMS_JOINED_DEALS';
export const getIsMismatchedDimensionDateFilterPropertyTimeSeries = report => {
  const dimensions = getDimensions(report);
  return getConfigType(report) === TIME_SERIES && (dimensions === null || dimensions === void 0 ? void 0 : dimensions.size) === 1 && dimensions.get(0) !== getDateRangeFilterProperty(getReportConfig(report));
};
export const getIsReportValidForComparisonDropdown = ({
  report
}) => {
  if (isConfigReport(report)) {
    // Once these reports are migrated to be on platform, we can remove this check
    if ([CUSTOM_WIDGET_TYPES.PIPELINE_SNAPSHOTS, CUSTOM_WIDGET_TYPES.SALES_QUOTA, CUSTOM_WIDGET_TYPES.ENGAGEMENT_STREAM, CUSTOM_WIDGET_TYPES.WATERFALL, CUSTOM_WIDGET_TYPES.CHANGE_HISTORY_DEAL_LIST, CUSTOM_WIDGET_TYPES.DEAL_PUSH_ANALYSIS].includes(getCustomWidgetType(report))) {
      return false;
    }
    const dataType = getDataType(report);
    if (dataType === EXT_LINE_ITEMS_JOINED_DEALS) {
      return false;
    }
    if (isMultiConfigReport(report) || isTableReport(report)) {
      // MultiConfig reports have custom visualization.The compare dataset is not accounted
      // for in the custom visualization.
      return false;
    }
    return !!getDateRangeFilter(getReportConfig(report)).get('value');
  }
  return false;
};